import type { FC } from 'react';

type RollbarErrorFallbackProps = {
  error: Error | null;
  resetError: () => void;
};

/**
 * Shown when the root Rollbar ErrorBoundary catches a render error.
 */
export const RollbarErrorFallback: FC<RollbarErrorFallbackProps> = ({ resetError }) => (
  <div
    role="alert"
    style={{
      boxSizing: 'border-box',
      minHeight: '100vh',
      padding: '2rem',
      fontFamily: 'system-ui, sans-serif',
      maxWidth: '36rem',
      margin: '0 auto',
    }}
  >
    <h1 style={{ fontSize: '1.25rem', marginBottom: '0.75rem' }}>Something went wrong</h1>
    <p style={{ marginBottom: '1.25rem', lineHeight: 1.5, color: '#333' }}>
      The application hit an unexpected error. The team has been notified. You can try reloading the page.
    </p>
    <button type="button" onClick={resetError} style={{ padding: '0.5rem 1rem', cursor: 'pointer' }}>
      Try again
    </button>
  </div>
);
